import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	placeholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	placeholder: {
		id: 'servicedesk-insight-attribute-views.project.placeholder',
		defaultMessage: 'No projects selected',
		description: 'Message displayed when there are no projects selected for an attribute',
	},
	placeholderGalaxia: {
		id: 'servicedesk-insight-attribute-views.project.placeholder-galaxia',
		defaultMessage: 'No spaces selected',
		description: 'Message displayed when there are no spaces selected for an attribute',
	},
});
